<template>
  <el-row class="login-user-left__icon-and-description" type="flex" justify="left" align="start">
    <div class="login-user-left__icon-and-description__icon-wrapper">
      <el-image
        style="width: 100%; height: 100%"
        :src="url"
        fit="scale-down"></el-image>
    </div>
    <el-col class="login-user-left__icon-and-description__description-wrapper pl-5">
      <p>
        {{description}}
      </p>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'LoginUserLeftIconAndDescription',

  props: ['url', 'description'],

  data() {
    return {
      dateExample: ''
    }
  },

  methods: {
  },

  computed: {
  },

  components: {
    // EyeOffIcon,
  },

  created() {}
}
</script>

<style lang="scss">
  .login-user-left__icon-and-description {
    .login-user-left__icon-and-description__icon-wrapper {
      width: 46px;
      height: 46px;
    }
    .login-user-left__icon-and-description__description-wrapper {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      p {
        font-size: 15px;
        font-weight: bold;
        line-height: 1.2;
        text-align: left;
        color: #ffffff;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Login/LoginUserLeftIconAndDescription.vue